export function timeoutPromise(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/gs-core/common/util/timoutPromise.ts